var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rounded-full px-3 py-1 text-xs font-medium tracking-wide",class:[
    {
      'text-red-600': _vm.rejected,
      'bg-red-100 bg-opacity-75': _vm.rejected,
      'text-green-600': !_vm.pending && !_vm.rejected,
      'bg-green-100 bg-opacity-75': !_vm.pending && !_vm.rejected,
      'text-white': !_vm.rejected && _vm.pending,
      'bg-black bg-opacity-75': !_vm.rejected && _vm.pending,
    },
  ]},[(_vm.rejected)?[_vm._v(" Rejected ")]:(_vm.pending)?[_vm._v(" In Review ")]:(_vm.approved)?[_vm._v(" Approved ")]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }